import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { Discount } from '@nucleus-commerce/api-client/admin';

/** "Entire order", "3 products" or "2 collections". */
export function useDiscountScope() {
  const { t } = useTranslation('discounts');
  return useCallback(
    (discount: Pick<Discount, 'appliesTo'>): string => {
      const { appliesTo } = discount;
      if (appliesTo.scope === 'products') {
        return t('scope.productsCount', { count: appliesTo.productIds.length });
      }
      if (appliesTo.scope === 'collections') {
        return t('scope.collectionsCount', { count: appliesTo.collectionIds.length });
      }
      return t('scope.orderSummary');
    },
    [t],
  );
}
